import { lang } from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { currentCommunity } from "../../API/store/actions/community";
import Lang from "../../userPreferences/staticWords";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { paths } from "./../../paths/paths";

const Slider = ({
  data,
  currentPage,
  setCurrentPage,
  openSlider,
  setOpenSlider,
}) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(null);
  let slides = data ? data?.data : [];
  const community = useSelector((state) => state.community.communityId);

  // const changeElementActiveClass = (element) => {
  //   let elements = document.querySelectorAll(".sliderItem");
  //   for (let i = 0; i < elements.length; i++) {
  //     elements[i].classList.remove("workGroupsActiveClass");
  //   }
  //   element.currentTarget.classList.add("workGroupsActiveClass");
  // };

  const onLeftClickHandler = (e) => {
    e.stopPropagation();
    if (getDir(getCurrentLangFromRedux()) === "ltr") {
      if (currentPage != 0) setCurrentPage(currentPage - 1);
    } else {
      if (currentPage != Math.ceil(data?.count / 2) - 1)
        setCurrentPage(currentPage + 1);
    }
  };

  const onRightClickHandler = (e) => {
    e.stopPropagation();
    if (getDir(getCurrentLangFromRedux()) === "ltr") {
      if (currentPage != Math.ceil(data?.count / 2) - 1)
        setCurrentPage(currentPage + 1);
    } else {
      if (currentPage != 0) setCurrentPage(currentPage - 1);
    }
  };

  // small to mid screens
  const onSmallLeftClickHandler = (e) => {
    e.stopPropagation();
    if (getDir(getCurrentLangFromRedux()) === "ltr") {
      if (currentPage != 0) setCurrentPage(currentPage - 1);
    } else {
      if (currentPage != Math.ceil(data?.count / 2) - 1)
        setCurrentPage(currentPage + 1);
    }
  };

  const onSmallRightClickHandler = (e) => {
    e.stopPropagation();
    if (getDir(getCurrentLangFromRedux()) === "ltr") {
      if (currentPage != Math.ceil(data?.count / 2) - 1)
        setCurrentPage(currentPage + 1);
    } else {
      if (currentPage != 0) setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <p className="m-0 p-2 px-4 mx-1 pt-3">{Lang.communities}</p>
      <div className="d-md-flex d-none pt-2 pb-3 justify-content-around">
        {slides?.length ? (
          slides.map((item, index) => {
            return (
              <Link
                key={index}
                to={`/communityDetails/${item.id}`}
                className={` d-flex flex-row align-items-center mx-3 py-3 sliderItem ${
                  item?.id == active || community?.id == item?.id
                    ? "workGroupsActiveClass"
                    : ""
                }`}
                id={item?.id}
                style={{
                  border: "1px solid #1A73E8",
                  borderRadius: 10,
                  width: "45%",
                  height: 100,
                  overflow: "auto",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  dispatch(
                    currentCommunity({
                      ...item,
                    })
                  );
                  setActive(item?.id);
                  setOpenSlider(false);
                }}
              >
                {item.logo ? (
                  <div className="px-2">
                    <img
                      src={`${paths.CommunityLogo}${item.id}/${item.logo}`}
                      width={40}
                      height={30}
                      alt={item.logo}
                    />
                  </div>
                ) : (
                  <div className="px-2">
                    <img
                      src="/assets/images/sync-1.png"
                      width={30}
                      height={30}
                      alt="communityLogo"
                    />
                  </div>
                )}
                <div className="px-2">
                  <p className="m-0" style={{ wordBreak: "break-word" }}>
                    {item?.name}
                  </p>
                </div>
              </Link>
            );
          })
        ) : (
          <div> لا يوجد </div>
        )}

        {/* <div
          style={{
            backgroundColor: "#1A73E8",
            height: 100,
            width: 100,
            cursor: "pointer",
            borderRadius: 10,
          }}
          className="d-flex flex-column justify-content-center text-center align-items-center itemNav"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 16 16"
          >
            <path
              id="ic_zoom_in_24px"
              d="M14.435,13.063h-.723l-.256-.247a5.955,5.955,0,1,0-.64.64l.247.256v.723L17.637,19,19,17.637Zm-5.489,0a4.117,4.117,0,1,1,4.117-4.117A4.111,4.111,0,0,1,8.946,13.063Z"
              transform="translate(-3 -3)"
              fill="white"
            />
          </svg>
          <p className="text-white m-0">عرض الكل</p>
        </div> */}
      </div>
      {slides?.length && (
        <div
          className={`d-md-flex d-none justify-content-center align-items-center pb-3 ${
            getDir(getCurrentLangFromRedux()) === "rtl"
              ? "flex-row"
              : "flex-row-reverse"
          }`}
        >
          <div
            style={{
              backgroundColor: "#E5F0FE",
              height: 28,
              width: 28,
              cursor: "pointer",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center text-center align-items-center itemNav"
            onClick={(e) => {
              onRightClickHandler(e);
            }}
          >
            <Icon
              size={22}
              color="#246DDB"
              name="caret-right"
              className="icon"
              style={{ display: "block" }}
            />
          </div>

          <p className="m-0 px-2">{currentPage + 1}</p>

          <div
            style={{
              backgroundColor: "#E5F0FE",
              height: 28,
              width: 28,
              cursor: "pointer",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center text-center align-items-center itemNav"
            onClick={(e) => {
              onLeftClickHandler(e);
            }}
          >
            <Icon
              size={22}
              color="#246DDB"
              name="caret-left"
              className="icon"
              style={{ display: "block" }}
            />
          </div>
        </div>
      )}
      {/* small to mid screens */}

      <div className="d-flex flex-column align-items-center d-md-none pt-2 pb-3">
        {slides?.length ? (
          slides.map((item, index) => {
            return (
              <div
                key={index}
                className={` d-flex flex-row align-items-center mx-3 my-2  py-3 sliderItem ${
                  item?.id == active ? "workGroupsActiveClass" : ""
                }`}
                style={{
                  border: "1px solid #1A73E8",
                  borderRadius: 10,
                  opacity: 1,
                  width: "90%",
                  height: 100,
                  overflow: "auto",
                  cursor: "pointer",
                }}
                id={item?.id}
                onClick={() => {
                  dispatch(
                    currentCommunity({
                      ...item,
                    })
                  );
                  setActive(item?.id);
                  setOpenSlider(false);
                }}
              >
                {item.logo ? (
                  <div className="px-2">
                    <img
                      src={`${paths.CommunityLogo}${item.id}/${item.logo}`}
                      width={40}
                      height={30}
                      alt={item.logo}
                    />
                  </div>
                ) : (
                  <div className="px-2">
                    <img
                      src="/assets/images/sync-1.png"
                      width={30}
                      height={30}
                      alt="communityLogo"
                    />
                  </div>
                )}
                <div className="px-2">
                  <p className="m-0" style={{ wordBreak: "break-word" }}>
                    {item?.name}
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <div> لا يوجد </div>
        )}
      </div>

      {slides?.length && (
        <div
          className={`d-flex d-md-none justify-content-center align-items-center pb-3 ${
            getDir(getCurrentLangFromRedux()) === "rtl"
              ? "flex-row"
              : "flex-row-reverse"
          }`}
        >
          <div
            style={{
              backgroundColor: "#E5F0FE",
              height: 28,
              width: 28,
              cursor: "pointer",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center text-center align-items-center itemNav"
            onClick={(e) => {
              onSmallRightClickHandler(e);
            }}
          >
            <Icon
              size={22}
              color="#246DDB"
              name="caret-right"
              className="icon"
              style={{ display: "block" }}
            />
          </div>

          <p className="m-0 px-2">{currentPage + 1}</p>

          <div
            style={{
              backgroundColor: "#E5F0FE",
              height: 28,
              width: 28,
              cursor: "pointer",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center text-center align-items-center itemNav"
            onClick={(e) => {
              onSmallLeftClickHandler(e);
            }}
          >
            <Icon
              size={22}
              color="#246DDB"
              name="caret-left"
              className="icon"
              style={{ display: "block" }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Slider;
